import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./bite_log_chase_event.js";
//#region src/bite_log_chase_event_helper.ts
var bite_log_chase_event_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(event) {
	switch (event) {
		case 0: return "ok";
		case 1: return "terminal-connected";
		case 2: return "terminal-disconnected";
		case 3: return "sale-transaction";
		case 4: return "sale-transaction-error";
		case 5: return "device-setup";
		case 6: return "close-transaction";
		case 7: return "close-transaction-error";
		case 8: return "refund-transaction-requested";
		case 9: return "refund-transaction";
		case 10: return "refund-transaction-error";
		case 11: return "logs";
	}
}
//#endregion
export { bite_log_chase_event_helper_exports, name };

//# sourceMappingURL=bite_log_chase_event_helper.js.map